function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 236.61 149.83"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5"
}, React.createElement("circle", {
  cx: "114.48",
  cy: "74.91",
  r: "72.66"
}), React.createElement("path", {
  d: "M154.52 90.53a882.2 882.2 0 0 1-33.19 7c-64.08 12.14-117.37 14.84-119 6-.95-5 14.14-12.41 40-20.33m143.41-27.58c28.59-2.41 47.6-1.22 48.58 4 1.21 6.38-25.06 17.06-64 27.07"
}), React.createElement("circle", {
  cx: "57.98",
  cy: "54.42",
  r: "4.97"
}), React.createElement("circle", {
  cx: "56.79",
  cy: "69.94",
  r: "4.97"
}), React.createElement("circle", {
  cx: "70.38",
  cy: "62.7",
  r: "4.97"
}), React.createElement("circle", {
  cx: "162.56",
  cy: "88.91",
  r: "7.34"
}))));